import { ErrorOutline } from '@mui/icons-material';

interface RejectionBannerProps {
  message: string;
  stepTitle?: string;
}

export const RejectionBanner: React.FC<RejectionBannerProps> = ({ message, stepTitle }) => (
  <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 flex gap-3">
    <ErrorOutline className="text-red-500 flex-shrink-0 mt-0.5" fontSize="small" />
    <div>
      <p className="font-semibold text-red-800 text-sm">
        Tu solicitud requiere correcciones
        {stepTitle ? ` en: ${stepTitle}` : ''}
      </p>
      <p className="text-red-700 text-sm mt-1">{message}</p>
    </div>
  </div>
);
